// ==============================|| PRESET THEME - DEFAULT ||============================== //

// Custom Agri-Green palette — natural / agriculture aesthetic.
// 10 shades from light to dark, mapped 1:1 by lightness onto the previous
// indigo ramp so every UI slot (header tints, buttons, links, headings) keeps
// the same balance and contrast — just green instead of indigo.
const trendingGreen = [
  '#f0fdf4', // 0  - lighter  → header backgrounds, footer totals (subtle green tint)
  '#dcfce7', // 1  - 100      → hover tints, soft fills
  '#bbf7d0', // 2  - 200      → secondary fills, disabled states
  '#86efac', // 3  - light    → light buttons, outlined hover
  '#4ade80', // 4  - 400      → bright accent
  '#16a34a', // 5  - main     → primary buttons, links, focus rings (green-600)
  '#15803d', // 6  - dark     → button hover (green-700)
  '#166534', // 7  - 700      → headings, deep emphasis (green-800)
  '#14532d', // 8  - darker   → strongest contrast (green-900)
  '#052e16'  // 9  - 900      → deepest accent (green-950)
];

export default function Default(colors) {
  const { red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: trendingGreen[0],
      100: trendingGreen[1],
      200: trendingGreen[2],
      light: trendingGreen[3],
      400: trendingGreen[4],
      main: trendingGreen[5],
      dark: trendingGreen[6],
      700: trendingGreen[7],
      darker: trendingGreen[8],
      900: trendingGreen[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
}